import * as React from 'react';
import api from '../api/apiClient';
import { Button, ButtonToolbar, Form, Modal } from 'react-bootstrap';
import { useParams } from 'react-router-dom';


interface ImportRaceDataParams {
	raceId?: string
}

interface ImportRaceDataState {
	file: any,
	messages: Array<string>,
	importing:any
}


class ImportRaceDataComponent extends React.Component<ImportRaceDataParams, ImportRaceDataState> {

	constructor(props) {
		super(props);

		this.startImport = this.startImport.bind(this);
		this.handleFileUpload = this.handleFileUpload.bind(this);		
	}

	componentWillMount() {
		this.setState({
			messages: [],
			importing: 0
		});
	}

	startImport() {
		var data = new FormData();
		data.append('file', this.state.file);

		this.setState({ importing: true });

		api.post('import/' + this.props.raceId, data).then(response => {
			console.log(response);

			this.setState({
				messages: response,
				importing:false
			});

		});		
	}

	handleFileUpload(e) {

		if (e.target.files.length > 0) {
			this.setState({ file: e.target.files[0] });
		}
		else {
			this.setState({ file: null });
		}

	}

	render() {
		return (
			<div>							

				<Modal show={this.state.importing} animation={false} backdropClassName="show">
					<Modal.Header>
						<Modal.Title></Modal.Title>
					</Modal.Header>
					<Modal.Body>
						Importing....
					</Modal.Body>
					<Modal.Footer>
					</Modal.Footer>
				</Modal>

				<form>
					<Form.Group controlId="file">
						<Form.Label>Database file</Form.Label>
						<div>
							<Form.Control type="file" onChange={this.handleFileUpload} />
						</div>
					</Form.Group>

					{(this.state.file) && 					
						<ButtonToolbar>
							<Button variant="primary" onClick={this.startImport}>Import</Button>
						</ButtonToolbar>					
					}
				</form>

				<fieldset>
					
					<legend>Log</legend>			
					{
						this.state.messages.map(message =>
							<div key={message}>{message}</div>
						)
					}
					
					
				</fieldset>				

			</div>
		);
	}
}

export default function ImportRaceDataPage() {
	const { raceid } = useParams();
	return <ImportRaceDataComponent raceId={raceid} />;
}
